/**
 * اختيار طبقة البيانات حسب VITE_DATA_MODE.
 * الوضع الافتراضي local ليعمل التطبيق فورًا دون أي خدمة خارجية.
 */

import type { DataGateway } from '@/data/types';
import { LocalGateway } from '@/data/local/gateway';
import { SupabaseGateway } from '@/data/supabase/gateway';
import { env } from '@/config/env';

let instance: DataGateway | null = null;

export function getGateway(): DataGateway {
  if (instance) return instance;
  instance = env.dataMode === 'supabase' ? new SupabaseGateway() : new LocalGateway();
  return instance;
}

/** للاختبارات أو عند تبديل البيئة يدويًا. */
export function setGateway(gateway: DataGateway | null): void {
  instance = gateway;
}

export function dataMode(): 'local' | 'supabase' {
  return getGateway().kind;
}
